<template>
    <div class="col-12 col-md-4 bg-white px-3 py-4 shadow-sm rounded-4 mb-2 position-relative mb-4">
        <div class="col-12 mb-2 position-absolute top-0 end-0 me-4">
            <span v-if="Number(info_goal_card.variable_points_to_win) > 0 && status_display && client_segment != 3" class="py-1 px-2 rounded text-dark text-end float-end d-flex justify-content-center -mt-10" :class="(Number(info_goal_card.advance_percentage) * 100) >= 100 ? 'box-points-goals' : 'bg-gradient bg-secondary bg-opacity-10'">
                <strong class="me-1">
                    {{ numberFormat(Number(info_goal_card.variable_points_to_win)) }}
                </strong>
                Puntos
            </span>
        </div>
        <div class="row pt-1 mb-1 d-flex justify-content-between">
            <div class="col-12">
                <h5 class="text-title-bat text-indigo-darkness">
                    {{ info_goal_card.variable }}
                </h5>
            </div>
        </div>
        <p class="mb-1 fs-6">
            Cumple tu meta:
            <span v-if="info_goal_card.unit_measure" class="text-title-bat text-indigo">{{ numberFormat(Math.round(Number(info_goal_card.goal))) }} {{ formatUnitMeasure(info_goal_card.unit_measure) }}</span>
            <span v-else class="text-title-bat text-indigo">{{ numberFormat(Math.round(Number(info_goal_card.goal))) }} Unidades</span>
        </p>
        <div>
            <el-progress :text-inside="true" :percentage="(Number(info_goal_card.advance_percentage) * 100) > 100 ? 100 : Math.floor(Number(info_goal_card.advance_percentage) * 100)"
                :color="customColorMethods"
                :show-text="true"
                class="my-3 mx-0"
                :stroke-width="18"
                :text-color="'white'">
            </el-progress>
        </div>
        <p class="text-end mb-1 fs-6">
            Llevas:
            <span v-if="info_goal_card.unit_measure" class="text-title-bat bg-opacity-10  p-2 ms-1 rounded" :class="(Number(info_goal_card.advance_percentage) * 100) >= 100 ? 'bg-success text-success' : 'bg-info text-indigo'">{{ numberFormat(Math.round(Number(info_goal_card.advance_amount))) }} {{ formatUnitMeasure(info_goal_card.unit_measure) }}</span>
            <span v-else class="text-title-bat bg-opacity-10  p-2 ms-1 rounded" :class="(Number(info_goal_card.advance_percentage) * 100) >= 100 ? 'bg-success text-success' : 'bg-info text-indigo'">{{ numberFormat(Math.round(Number(info_goal_card.advance_amount))) }} Unidades</span>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        info_goal_card: {
            default: null,
        },
        client_segment: {
            default: null,
        },
        status_display: {
            default: false,
        },
    },
    data() {
        return {
            // 
        };
    },
    mounted() {
        // 
    },
    methods: {
        numberFormat(number) {
            const exp = /(\d)(?=(\d{3})+(?!\d))/g
            const rep = '$1.'
            let arr = number.toString().split('.')
            arr[0] = arr[0].replace(exp, rep)
            return arr[1] ? arr.join(',') : arr[0]
        },
        formatUnitMeasure(text){
            return text[0].toUpperCase() + text.substring(1).toLowerCase();
        },
        customColorMethods(percentage) {
            if (percentage >= 100) {
                return 'green';
            } else if (percentage >= 50 && percentage < 100) {
                return 'orange';
            } else {
                return 'red';
            }
        },
    },
};
</script>